import React, { useState } from "react";
import LessonReportsList from "../../components/report/LessonReportsList";

const AdminReportsPage = () => {
    const [showUnconfirmedOnly, setShowUnconfirmedOnly] = useState(true);
    const [showUnSuggestedOnly, setShowUnSuggestedOnly] = useState(false);
    const [refresh, setRefresh] = useState(false); // 🔹 `refresh` ステートを追加

    return (
        <div className="p-3 pt-20">
            <h1 className="text-2xl font-bold mb-4">📝 報告書一覧</h1>

            {/* 🔹 未確認のみ表示ボタン */}
            <div className="mb-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        className="w-5 h-5"
                        checked={showUnconfirmedOnly}
                        onChange={() => setShowUnconfirmedOnly(prev => !prev)}
                    />
                    <span className="text-lg">未確認の報告書のみ表示</span>
                </label>
            </div>

            <div className="mb-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        className="w-5 h-5"
                        checked={showUnSuggestedOnly}
                        onChange={() => setShowUnSuggestedOnly(prev => !prev)}
                    />
                    <span className="text-lg">AI未提案の報告書のみ表示</span>
                </label>
            </div>


            {/* 🔹 報告書リスト */}
            <LessonReportsList
                isAdmin={true}
                showUnconfirmedOnly={showUnconfirmedOnly}
                showUnSuggestedOnly={showUnSuggestedOnly}
                refresh={refresh}
                setRefresh={setRefresh}
            />
        </div>
    );
};

export default AdminReportsPage;
